import React, { useState } from 'react';
import { X } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
export function FooterSection() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-charcoal text-cream/40 py-8 text-center text-sm border-t border-white/10" data-id="element-40">
        <p data-id="element-41">
          © {new Date().getFullYear()} Menopausia
Sin Fármacos. Todos los derechos reservados.
        </p>
        <p className="mt-2 text-xs max-w-2xl mx-auto px-6" data-id="element-42">
          Este producto no sustituye el consejo médico profesional. Los
          resultados pueden variar.
        </p>
        <div className="mt-4 flex items-center justify-center gap-4" data-id="element-43">
          <button onClick={() => setActiveModal('privacy')} className="text-cream/50 hover:text-copper transition-colors underline underline-offset-2 cursor-pointer" data-id="element-44">
            Política de Privacidad
          </button>
          <span className="text-cream/20" data-id="element-45">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-cream/50 hover:text-copper transition-colors underline underline-offset-2 cursor-pointer" data-id="element-46">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <AnimatePresence data-id="element-47">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-48">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="bg-charcoal border border-copper/20 rounded-sm max-w-2xl w-full max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-49">
              <div className="flex items-center justify-between px-6 py-4 border-b border-white/10" data-id="element-50">
                <h3 className="text-cream font-serif text-xl" data-id="element-51">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-cream/40 hover:text-copper transition-colors p-1" aria-label="Cerrar" data-id="element-52">
                  <X className="w-5 h-5" data-id="element-53" />
                </button>
              </div>

              <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] text-cream/70 text-sm leading-relaxed space-y-4" data-id="element-54">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-55" /> : <TermsContent data-id="element-56" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-cream/50 text-xs uppercase tracking-widest" data-id="element-57">
        Última actualización: Abril 2026
      </p>

      <h4 className="text-copper font-serif text-lg mt-2" data-id="element-58">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-59">
        Recopilamos información personal que nos proporcionas directamente al
        realizar una compra, como tu nombre, dirección de correo electrónico y
        datos de pago. Los datos de pago son procesados de forma segura por
        nuestros proveedores de pago y no almacenamos información de tarjetas de
        crédito en nuestros servidores.
      </p>

      <h4 className="text-copper font-serif text-lg" data-id="element-60">
        2. Uso de la Información
      </h4>
      <p data-id="element-61">
        Utilizamos tu información personal para: procesar y entregar tu compra,
        enviarte actualizaciones relacionadas con el producto, mejorar nuestros
        servicios y cumplir con obligaciones legales. No vendemos ni compartimos
        tu información personal con terceros para fines de marketing.
      </p>

      <h4 className="text-copper font-serif text-lg" data-id="element-62">
        3. Cookies y Tecnologías de Seguimiento
      </h4>
      <p data-id="element-63">
        Nuestro sitio web puede utilizar cookies y tecnologías similares para
        mejorar tu experiencia de navegación y analizar el tráfico del sitio.
        Puedes configurar tu navegador para rechazar cookies, aunque esto puede
        afectar la funcionalidad del sitio.
      </p>

      <h4 className="text-copper font-serif text-lg" data-id="element-64">
        4. Seguridad de los Datos
      </h4>
      <p data-id="element-65">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado, pérdida o
        alteración. Sin embargo, ningún método de transmisión por Internet es
        100% seguro.
      </p>

      <h4 className="text-copper font-serif text-lg" data-id="element-66">5. Tus Derechos</h4>
      <p data-id="element-67">
        Tienes derecho a acceder, rectificar o eliminar tu información personal.
        También puedes solicitar la portabilidad de tus datos o retirar tu
        consentimiento en cualquier momento. Para ejercer estos derechos,
        contáctanos a través de los canales proporcionados.
      </p>

      <h4 className="text-copper font-serif text-lg" data-id="element-68">
        6. Cambios en esta Política
      </h4>
      <p data-id="element-69">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Te notificaremos sobre cambios significativos a
        través de nuestro sitio web o por correo electrónico.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-cream/50 text-xs uppercase tracking-widest" data-id="element-70">
        Última actualización: Abril 2026
      </p>

      <h4 className="text-copper font-serif text-lg mt-2" data-id="element-71">
        1. Aceptación de los Términos
      </h4>
      <p data-id="element-72">
        Al acceder y utilizar este sitio web y adquirir el programa RESET 21,
        aceptas estar sujeto a estos términos y condiciones. Si no estás de
        acuerdo con alguno de estos términos, no utilices nuestros servicios.
      </p>

      <h4 className="text-copper font-serif text-lg" data-id="element-73">
        2. Descripción del Producto
      </h4>
      <p data-id="element-74">
        RESET 21 es un programa digital de bienestar que incluye guías,
        protocolos y material educativo. El contenido es de carácter informativo
        y educativo, y no constituye asesoramiento médico profesional. Los
        resultados pueden variar según cada individuo.
      </p>

      <h4 className="text-copper font-serif text-lg" data-id="element-75">3. Licencia de Uso</h4>
      <p data-id="element-76">
        Al completar tu compra, recibes una licencia personal, intransferible y
        no exclusiva para acceder y utilizar el contenido del programa. Queda
        prohibida la reproducción, distribución o reventa del material sin
        autorización expresa.
      </p>

      <h4 className="text-copper font-serif text-lg" data-id="element-77">
        4. Política de Reembolso
      </h4>
      <p data-id="element-78">
        Debido a la naturaleza digital del producto y al acceso inmediato
        proporcionado tras la compra, no se ofrecen reembolsos una vez que se ha
        accedido al contenido, salvo en circunstancias excepcionales evaluadas
        caso por caso.
      </p>

      <h4 className="text-copper font-serif text-lg" data-id="element-79">
        5. Limitación de Responsabilidad
      </h4>
      <p data-id="element-80">
        AEduclub no se hace responsable de daños directos, indirectos o
        consecuentes derivados del uso del programa. El usuario asume toda la
        responsabilidad por las decisiones tomadas basándose en el contenido
        proporcionado. Consulta siempre con un profesional de la salud antes de
        realizar cambios en tu dieta o estilo de vida.
      </p>

      <h4 className="text-copper font-serif text-lg" data-id="element-81">
        6. Propiedad Intelectual
      </h4>
      <p data-id="element-82">
        Todo el contenido del programa RESET 21, incluyendo textos, gráficos,
        diseños y materiales audiovisuales, es propiedad exclusiva de AEduclub y
        está protegido por las leyes de propiedad intelectual aplicables.
      </p>

      <h4 className="text-copper font-serif text-lg" data-id="element-83">7. Modificaciones</h4>
      <p data-id="element-84">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios entrarán en vigor desde su publicación en el sitio
        web. El uso continuado del servicio implica la aceptación de los
        términos modificados.
      </p>
    </>;
}